import { render, staticRenderFns } from "./OrgUsersDepartments.vue?vue&type=template&id=f47c5242&scoped=true&"
import script from "./OrgUsersDepartments.vue?vue&type=script&lang=js&"
export * from "./OrgUsersDepartments.vue?vue&type=script&lang=js&"
import style0 from "./OrgUsersDepartments.vue?vue&type=style&index=0&id=f47c5242&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47c5242",
  null
  
)

export default component.exports